import { Translation, Trans } from 'react-i18next';
import React from 'react';

import {
  ColumnProps,
  FollowButton,
  NavLink,
  UserAvatar,
  UserCardPopup,
  HelperTooltip,
} from '@/components';
import style from './index.module.css';
import { formatDate, shortenAddress } from '@/utils';
import { GiftVipHistoryItem } from '../types';
import { IconRcFeedRank } from '@/assets/stream';

export const getGiftHistoryColumns = (
  handleFollowChange: (address: string, isFollow: boolean) => void,
  hideModal: () => void,
  currentUserId?: string,
): Array<ColumnProps<GiftVipHistoryItem>> => {
  return [
    {
      width: '42%',
      key: 'creator',
      title: <Translation>{t => t('GiftVipHistoryModal_columns.bd0mup')}</Translation>,

      render({ row }) {
        const buyerId = row.buyer.id;
        const followCallback = (isFollow: boolean) => handleFollowChange(buyerId, isFollow);
        return (
          <NavLink onClick={hideModal} to={`/profile/${buyerId}`} className={style.userCell}>
            <UserAvatar
              className={style.avatar}
              size={48}
              data={row.buyer?.desc}
              userCardPopup={{
                followCallback,
              }}
            />
            <div className={style.operationUserMain}>
              <div className={style.commentHead}>
                <UserCardPopup address={buyerId} followCallback={followCallback}>
                  <div className={style.uid}>{row.buyer.web3_id || shortenAddress(buyerId)}</div>
                </UserCardPopup>
              </div>
              <Translation>
                {t => (
                  <HelperTooltip title={t('GiftVipHistoryModal_columns.1h0gg1w')}>
                    <div className={style.content}>
                      <IconRcFeedRank /> <span>{row.buyer.rank_at}</span>
                    </div>
                  </HelperTooltip>
                )}
              </Translation>
            </div>
          </NavLink>
        );
      },
    },
    {
      width: '40%',
      key: 'result',
      title: <Trans i18nKey="GiftVipHistoryModal_columns.gifted-vip-duration"></Trans>,
      render({ row }) {
        return (
          <div className={style.durationCell}>
            <div className={style.duration}>
              <Translation>
                {t => t('PaidFeatureModal.1pysn4', { count: row.duration })}
              </Translation>
            </div>
            <div className={style.startToEnd}>
              {formatDate(row.start_at * 1000, 'YYYY/MM/DD')}~
              {formatDate(row.end_at * 1000, 'YYYY/MM/DD')}
            </div>
          </div>
        );
      },
    },
    {
      width: '18%',
      key: 'follow',
      title: '',
      render({ row }) {
        return currentUserId === row.buyer.id ? null : (
          <FollowButton
            className={style.followButton}
            userInfo={row.buyer}
            address={row.buyer.id}
          />
        );
      },
    },
  ];
};
